import React from 'react';
import { Button, Container, Typography, Box } from '@mui/material';
import { useNotificationManager } from '../hooks/useNotificationManager';

const NotificationTest = () => {
  const { showSuccess, showError, showInfo, showWarning, clearHistory } = useNotificationManager();

  const handleTestSuccess = () => {
    showSuccess("Teste de sucesso!", {
      description: "Esta é uma notificação de sucesso",
      duration: 3000,
    });
  };

  const handleTestError = () => {
    showError("Teste de erro!", {
      description: "Esta é uma notificação de erro",
      duration: 3000,
    });
  };

  const handleTestMultiple = () => {
    // Tentar mostrar múltiplas notificações do mesmo tipo rapidamente
    showError("Erro 1", { description: "Primeiro erro" });
    showError("Erro 1", { description: "Primeiro erro (duplicado)" });
    showError("Erro 2", { description: "Segundo erro" });
    showError("Erro 1", { description: "Primeiro erro novamente" });
  };

  const handleClearHistory = () => {
    clearHistory();
    showInfo("Histórico limpo!", {
      description: "O histórico de notificações foi limpo",
      duration: 2000,
    });
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Teste de Notificações
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button variant="contained" color="success" onClick={handleTestSuccess}>
          Teste Sucesso
        </Button>
        
        <Button variant="contained" color="error" onClick={handleTestError}>
          Teste Erro
        </Button>
        
        <Button variant="contained" color="warning" onClick={handleTestMultiple}>
          Teste Múltiplos (Deduplicação)
        </Button>
        
        <Button variant="outlined" onClick={handleClearHistory}>
          Limpar Histórico
        </Button>
      </Box>
    </Container>
  );
};

export default NotificationTest;
